'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'box-ballot';
var width = 512;
var height = 512;
var aliases = [128499];
var unicode = 'f735';
var svgPathData = 'M171.9 121.4l101.5-101.5 82.7 82.7-101.5 101.5-82.7-82.7zm-33.9 33.9l68.6 68.6-86.6 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l272 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-89.4 0 87.5-87.5c18.7-18.7 18.7-49.1 0-67.9L307.4-14.1c-18.7-18.7-49.1-18.7-67.9 0L137.9 87.5c-18.7 18.7-18.7 49.1 0 67.9zM418.5 176l29.5 0c8.8 0 16 7.2 16 16l0 144-416 0 0-144c0-8.8 7.2-16 16-16l28.7 0c-10.2-14.5-15.8-31.1-17-48L64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35-28.1-63.4-62.9-64-4.2 15.3-12.4 29.8-24.4 41.8l-6.2 6.2zM464 384l0 64c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-64 416 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBoxBallot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;